import { render, staticRenderFns } from "./Iteminfo.vue?vue&type=template&id=30a4f2c4&scoped=true&"
import script from "./Iteminfo.vue?vue&type=script&lang=js&"
export * from "./Iteminfo.vue?vue&type=script&lang=js&"
import style0 from "./Iteminfo.vue?vue&type=style&index=0&id=30a4f2c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a4f2c4",
  null
  
)

export default component.exports